var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"iframe-popup"},[(_setup.loading)?_c(_setup.LoadingSpinner):_vm._e(),_c('iframe',{directives:[{name:"show",rawName:"v-show",value:(!_setup.loading),expression:"!loading"}],attrs:{"id":"iframePopupModal","src":"https://www.ketchup.academy/pricing-popup"},on:{"load":_setup.iframeLoaded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }